// Material UI
import { makeStyles } from '@material-ui/core'
// constant
import Colors from '../../constants/Colors'

export default makeStyles(theme => {
  return {
    root: {
      border: `1px solid ${Colors.DISABLED_COLOR}`,
      borderRadius: 8,
    },
    title: {
      fontSize: 13,
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      textAlign: 'center',
      color: Colors.SECONDARY_FONT_COLOR,
      paddingTop: 12,
    },
    number: {
      fontSize: '17px',
      fontWeight: 'bold',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      textAlign: 'center',
      color: Colors.PRIMARY_FONT_COLOR,
      paddingTop: 6,
      paddingBottom: 12,
    },
  }
})
